import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export function toShortDate(date, separator='-') {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const format =`DD${separator}MM${separator}YYYY`;
    return dayjs(date).format(format);
  }